/* VIRIUM — comportamenti condivisi sezioni vr-* */
(function(){
  function reveal(){
    var els=document.querySelectorAll('.vr-rv:not(.is-in)');
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-in')});return;}
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('is-in');io.unobserve(x.target);}})},{rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(e){io.observe(e)});
  }
  /* link "scroll al selettore" : qualsiasi elemento con [data-vr-scroll] */
  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-vr-scroll]');
    if(!t)return;
    var target=document.querySelector(t.getAttribute('data-vr-scroll'));
    if(!target)return; /* se il selettore non c'è (es. home) segue il link normale */
    e.preventDefault();
    var y=target.getBoundingClientRect().top+window.pageYOffset-90;
    window.scrollTo({top:y,behavior:'smooth'});
  });
  if(document.readyState!=='loading')reveal();else document.addEventListener('DOMContentLoaded',reveal);
  document.addEventListener('shopify:section:load',reveal);
})();
